import React from "react";

import withRouter from "../../custom/withRouter";
import CircularProgress from "@mui/material/CircularProgress";
import Backdrop from "@mui/material/Backdrop";
import SubscriptionListViewTable from "../../custom/SubscriptionListView";
import ApplicationListViewTable from "../../custom/ApplicatoinListView";
import { connect } from "react-redux";
import {
  AddGroup,
  AddMemberInGroup,
  AllGroups,
  AssignedMembers,
  DeleteGroup,
  DeleteMemberFromGroup,
  GroupEdit,
  UnAssignedMembers,
} from "../../../action/GroupApi";
import CommonIcon from "../../helpers/icons";
import $, { data } from "jquery";
import GroupListView from "../../custom/GroupListview";
import { unAssignedUsers } from "../../../action/ApplicationApi";
import {
  TextField,
  Avatar,
  Autocomplete,
  Paper,
  FormLabel,
  Switch,
  Button,
} from "@mui/material";
import { toast, ToastContainer } from "react-toastify";
import { TextareaAutosize, Tooltip } from "@material-ui/core";
import toggleMenu from "../../../redux/SideBar/sideBarActions";
import CustomListView from "../MUIDataTable/CustomListView";

class Groups extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isWebMobile: false,
      tempDescription: "",
      opendialogun: false,
      totalcount: 0,
      totalPages: 0,
      currentPage: "",
      selecteduserssss: [],
      editGroup: false,
      memberError: false,
      pageSize: 0,
      pageIndex: 10,
      columnFilter: [],
      sortingFilters: [],
      isFilterApplied: false,
      isFilterAppliedRole: false,
      columnHeaders: [
        { key: "groupname", label: "Group Name", width: "20%" },
        { key: "owner", label: "Total Members", width: "20%" },
        { key: "description", label: "Description", width: "20%" },
        { key: "action", label: "Action", width: "20%" },
      ],
      columngroupMemebers: [
        // { key: "members", label:"Members", width: "20%" },
        { key: "name", label: "Name", width: "30%" },
        { key: "email", label: "Email", width: "30%" },
        { key: "action", label: "Action", width: "20%" },
      ],
      normalData: [],
      groupedData: {},
      groupedColumn: null,
      collapsedGroups: {},
      isMobile: false,

      groupName: "",
      groupId: "",
      assignedGroupMembers: [],
      showdetails: true,
      showmember: false,
      showsroles: false,
      unAssignedUsers: [],
      newgroupname: "",
      selectedUserEmails: [],
      selectedUserID: [],
      selectedUser: null,
      description: "",
      newgroupnameerror: "",
      choice: {
        application: "",
        subscriptionStatus: 0,
        purchasedDate: null,
        groupName: "",
        name: "",
        email: "",
      },
      filterOptions: {
        application: "",
        subscriptionStatus: 0,
        purchasedDate: null,
        groupName: "",
        name: "",
        email: "",
      },
      filters: {
        limit: 15,
        offset: 0,
        SortBy: "name",
        sortByOrder: "asc",
        application: "",
        subscriptionStatus: "Subscribed",
        expiryDate: null,
        pageNumber: 1,
        PageSize: 10,
      },
      openmemberdelete: false,
      userdeleteid: "",
      userdeleteemail: "",
      columns: [
        {
          accessorKey: "name",
          header: "Name",
        },
        {
          accessorKey: "email",
          header: "Email",
        },
        {
          accessorKey: "action",
          header: "Action",
          minSize: 50,
          maxSize: 50,
          enableColumnActions: false,
          enableSorting: false,
          enableColumnFilter: false,
          muiTableHeadCellProps: {
            sx: {
              borderTop: "1px solid rgba(224, 224, 224, 1)",
              "& .Mui-TableHeadCell-Content-Labels": {
                paddingLeft: "0px",
                fontWeight: "400",
              },
            },
          },
          Cell: ({ cell, row }) => {
            return (
              <span
                className="cursor-pointer"
                onClick={() =>
                  this.handleDelete(row.original.userId, row.original.email)
                }
              >
                <CommonIcon fileName={"DeleteIcon"} />
              </span>
            );
          },
        },
      ],
    };
  }

  customToast = (message) => {
    toast(message, {
      hideProgressBar: true,
      autoClose: 2000, // Customize time as per your requirement
      closeOnClick: false,
      pauseOnHover: false,
      draggable: false,
      position: "top-right",
      className: "custom-toast", // Add a custom class here
    });
  };

  componentDidMount = () => {
    let data = {
      sortOrder: this.state.filters.sortByOrder,
      sortBy: this.state.filters.SortBy,
    };
    this.getAllApplicationData(data);
    const intervals = setInterval(() => {
      this.resize();
    }, 10);
  };
  getAllApplicationData = (data, tableLoader, resetTableOrder = false) => {
    tableLoader
      ? this.setState({ isLoader: true })
      : this.setState({ isloading: true });
    this.props.dispatch(AllGroups(data)).then((response) => {
      console.log(response.data);
      this.processData(response.data, tableLoader, resetTableOrder);
    });
  };
  getAllApplicationData1 = (data, tableLoader, resetTableOrder = false) => {
    tableLoader
      ? this.setState({ isLoader: true })
      : this.setState({ isloading: true });
    this.props.dispatch(AllGroups(data)).then((response) => {
      console.log(response.data);
      this.processData1(response.data, tableLoader, resetTableOrder);
    });
  };
  processData = (result, tableLoader, resetTableOrder) => {
    const normalData = !resetTableOrder ? this.state.normalData || [] : [];
    const newData = [];
    console.log(result);

    if (Array.isArray(result)) {
      result.forEach((value) => {
        const applicationData = {
          ...value,
        };
        normalData.push(applicationData);
        newData.push(applicationData);
      });
    }
    console.log(normalData);
    const isValue = newData.length >= 10 ? false : true;
    this.setState({
      normalData: normalData,
      isLoader: false,
      isloading: false,
      isScroll: isValue,
    });
  };
  processData1 = (result, tableLoader, resetTableOrder) => {
    const normalData = [];
    const newData = [];
    console.log(result);

    if (Array.isArray(result)) {
      result.forEach((value) => {
        const applicationData = {
          ...value,
        };
        normalData.push(applicationData);
        newData.push(applicationData);
      });
    }
    console.log(normalData);
    const matchedGroup = normalData.find(
      (item) => item.groupId === this.state.groupId
    );
    if (matchedGroup) {
      this.setState({
        groupName: matchedGroup?.groupName,
        groupId: matchedGroup?.groupId,
        description: matchedGroup?.description,
        totalMembers: matchedGroup?.totalMembers,
      });
    }

    const isValue = newData.length >= 10 ? false : true;
    this.setState({
      normalData: normalData,
      isLoader: false,
      isloading: false,
      isScroll: isValue,
    });
  };
  handleScroll = () => {
    if (!this.state.isScroll) {
      this.setState(
        (prevState) => ({
          ...prevState,
          isLoader: true,
          filtered: {
            ...prevState.filtered,
            offset: prevState.filtered.offset + 10,
          },
        }),
        () => {
          let tableLoader = true;
          this.getAllApplicationData(this.state.filtered, tableLoader);
        }
      );
    }
  };

  handleSort = (column) => {
    console.log(column);

    const { choice, filters } = this.state;
    let sortByOrder = "asc";

    if (filters.sortByOrder == "asc") {
      sortByOrder = "desc";
    }
    let data = {
      Name: choice.name,
      Email: choice.email,
      SortBy: column.toLowerCase(),
      SortOrder: sortByOrder,
      PageNumber: filters.pageNumber,
      PageSize: filters.PageSize,
    };
    console.log(data, "data");

    this.state.groupedColumn = null;

    this.state.groupedData = {};
    this.state.filters.SortBy = column;
    this.state.filters.sortByOrder = sortByOrder;
    console.log(this.state.filters.sortByOrder);

    // this.state.filters = data;
    let tableLoader = true;
    this.setState({ showmember: true, showdetails: false, showsroles: false });

    this.props
      .dispatch(AssignedMembers(this.state.groupId, data))
      .then((res) => {
        console.log(res.pagination.currentPage);

        this.setState({
          assignedGroupMembers: res.data,
          totalPages: res.pagination.totalPages,
          totalCount: res.pagination.totalCount,
          currentPage: res.pagination.currentPage,
        });
      });
  };
  handleEditId = (groupId, groupName, description, totalMembers) => {
    console.log(description);
    this.setState({ editGroup: false });

    this.setState({ showmember: false, showdetails: true, showsroles: false });
    this.setState({
      groupName: groupName,
      groupId: groupId,
      description: description,
      totalMembers: totalMembers,
    });
    this.setState({ choice: { name: "", email: "" } });
    this.newFormShow();
  };

  handleDelete = (id, email) => {
    this.setState({
      openmemberdelete: true,
      userdeleteid: id,
      userdeleteemail: email,
    });
    console.log(id, email, "jkjhk");
  };
  noActions = () => {
    this.setState({
      openmemberdelete: false,
      userdeleteemail: "",
      userdeleteid: "",
    });
  };

  yesActions = () => {
    this.setState({
      openmemberdelete: false,
    });
    let data = {
      userId: this.state.userdeleteid,
      email: this.state.userdeleteemail,
    };
    this.props
      .dispatch(DeleteMemberFromGroup(data, this.state.groupId))
      .then((res) => {
        if (this.state.isMobile) {
          this.allApicalls();
        } else {
          this.allApicalls1();
        }
        this.customToast("User deleted from group");
        this.setState({ userdeleteid: "", userdeleteemail: "" });
        let data = {
          sortOrder: this.state.filters.sortByOrder,
          sortBy: this.state.filters.SortBy,
        };
        this.getAllApplicationData1(data);
      });
  };
  newFormShow = () => {
    const offcanvasElement = document.getElementById("AddForm2");

    if (offcanvasElement && offcanvasElement.classList.contains("show")) {
      console.log("Offcanvas is already open.");
      return; // Exit the function if Offcanvas is already open
    }
    let myOffcanvas = new window.bootstrap.Offcanvas(offcanvasElement);
    myOffcanvas.show();

    $("body").addClass("scrollhide");
    $(".main-content").addClass("scrollhide");

    this.setState({
      backdrop: true,
    });
  };
  newGroupFormShow = () => {
    console.log("helllllp");

    let myOffcanvas = new window.bootstrap.Offcanvas(
      document.getElementById("AddGroup")
    );
    this.setState({ newgroupnameerror: "", description: "" });
    myOffcanvas.show();
    $("body").addClass("scrollhide");
    $(".main-content").addClass("scrollhide");
    this.setState({
      backdrop: true,
    });
  };
  closeForm = () => {
    $("#AddForm2").removeClass("show");

    $(".offcanvas-backdrop").removeClass("show");
    $("body").removeClass("scrollhide");
    $(".main-content").removeClass("scrollhide");
    let data = {
      sortBy: this.state.filters.SortBy,
      sortByOrder: this.state.filters.sortByOrder,
      pageNumber: this.state.filters.pageNumber,
      pageSize: this.state.filters.PageSize,
      application: this.state.filters.application,
      subscriptionStatus: this.state.filters.subscriptionStatus,
    };
    // this.getAllApplicationData(data, false, true)
    this.setState({
      selectedItem: {
        availableLicenses: 0,
      },
      backdrop: false,
      isAddingResource: false,
      selectedRoleId: null,
      isEditing: false,
      newgroupname: "",
      description: "",
    });
  };

  closeGroupForm = () => {
    $("#AddGroup").removeClass("show");
    $(".offcanvas-backdrop").removeClass("show");
    $("body").removeClass("scrollhide");
    $(".main-content").removeClass("scrollhide");
    let data = {
      sortBy: this.state.filters.SortBy,
      sortByOrder: this.state.filters.sortByOrder,
      pageNumber: this.state.filters.pageNumber,
      pageSize: this.state.filters.PageSize,
      application: this.state.filters.application,
      subscriptionStatus: this.state.filters.subscriptionStatus,
    };
    // this.getAllApplicationData(data, false, true)
    this.setState({
      newgroupname: "",
      description: "",
    });
    this.setState({
      selectedItem: {
        availableLicenses: 0,
        description: "",
      },
      backdrop: false,
      isAddingResource: false,
      selectedRoleId: null,
      isEditing: false,
    });
  };
  handleDataFetch = (pageSize, pageIndex, columnsFilters, sorting) => {
    debugger;
    this.setState({
      pageSize: pageSize,
      pageIndex: pageIndex,
      columnFilter: columnsFilters,
      sortingFilters: sorting,
    });

    const filterObject = columnsFilters.reduce((acc, curr) => {
      acc[curr.id] = curr.value;
      return acc;
    }, {});
    let sortorder = !sorting[0]?.desc;
    // let data = {
    //     sortBy: sorting[0]?.id,
    //     sortByOrder: sortorder ? "asc" : 'desc',
    //     isActive: null,
    //     limit: pageIndex,
    //     offset: pageSize * pageIndex,
    //     status: filterObject.isActive ?? null,
    //     name: filterObject.name ?? "",
    //     email: filterObject.email ?? "",
    //     lastLoginDate: filterObject.lastLoginDate ? moment(filterObject.lastLoginDate).format("YYYY-MM-DD") : null,
    // };
    let data = {
      Name: filterObject.name ?? "",
      Email: filterObject.email ?? "",
      SortBy: sorting[0]?.id ?? "name",
      SortOrder: sortorder ? "asc" : "desc",
      PageNumber: pageSize + 1,
      PageSize: pageIndex,
    };

    console.log(data);
    this.getAssignedMembers(data);
  };

  getAssignedMembers = (data) => {
    this.setState({ tableLoader: true });
    this.props
      .dispatch(AssignedMembers(this.state.groupId, data))
      .then((res) => {
        console.log(res.pagination.currentPage);

        this.setState((prev) => ({
          assignedGroupMembers: res.data,
          totalPages: res.pagination.totalPages,
          totalCount: res.pagination.totalCount,
          currentPage: res.pagination.currentPage,
          filters: {
            ...prev.filters,

            PageSize: res.pagination.pageSize,
          },
        }));
        this.setState({ tableLoader: false });
      })
      .catch((error) => {
        console.log(error);
        this.setState({ tableLoader: false });
      });
  };

  members = () => {
    this.setState({ showmember: true, showdetails: false, showsroles: false });
    const { choice, filters } = this.state;

    let data = {
      Name: choice.name,
      Email: choice.email,
      SortBy: filters.SortBy,
      SortOrder: filters.sortByOrder,
      PageNumber: 1,
      PageSize: 10,
    };
    this.setState(
      (prevState) => (
        {
          filters: {
            ...prevState.filters,
            pageNumber: 1,
            pageSize: 10,
          },
        },
        () => {
          console.log(this.state.filters);
        }
      )
    );

    // this.props.dispatch(AssignedMembers(this.state.groupId, data)).then((res) => {
    //     console.log(res.pagination.currentPage);

    //     this.setState((prev) => ({
    //         assignedGroupMembers: res.data, totalPages: res.pagination.totalPages, totalCount: res.pagination.totalCount, currentPage: res.pagination.currentPage, filters: {
    //             ...prev.filters,

    //             PageSize: res.pagination.pageSize
    //         }
    //     }))
    // })
    this.props.dispatch(UnAssignedMembers(this.state.groupId)).then((res) => {
      this.setState({ unAssignedUsers: res.data });
    });
  };
  members1 = () => {
    debugger;
    this.setState({ showmember: true, showdetails: false, showsroles: false });
    const { choice, filters } = this.state;

    let data = {
      Name: choice.name,
      Email: choice.email,
      SortBy: filters.SortBy,
      SortOrder: filters.sortByOrder,
      PageNumber: 1,
      PageSize: 10,
    };
    this.setState(
      (prevState) => (
        {
          filters: {
            ...prevState.filters,
            pageNumber: 1,
            pageSize: 10,
          },
          choice: {
            ...prevState.choice,
            name: this.state.choice.name ?? "",
            email: this.state.choice.email ?? "",
          },
        },
        () => {
          console.log(this.state.filters);
        }
      )
    );
    if (this.state.choice.name || this.state.choice.email) {
      this.setState({ isFilterAppliedRole: true });
    } else {
      this.setState({ isFilterAppliedRole: false });
    }

    this.props
      .dispatch(AssignedMembers(this.state.groupId, data))
      .then((res) => {
        console.log(res.pagination.currentPage);

        this.setState((prev) => ({
          assignedGroupMembers: res.data,
          totalPages: res.pagination.totalPages,
          totalCount: res.pagination.totalCount,
          currentPage: res.pagination.currentPage,
          filters: {
            ...prev.filters,

            PageSize: res.pagination.pageSize,
          },
        }));
      });
    this.props.dispatch(UnAssignedMembers(this.state.groupId)).then((res) => {
      this.setState({ unAssignedUsers: res.data });
    });
  };
  roles = () => {
    this.setState({ showmember: false, showdetails: false, showsroles: true });
  };

  details = () => {
    this.closeUserGroupForm();
    this.setState({
      editGroup: false,
      newgroupnameerror: "",
      description: this.state.tempDescription,
    });
    this.setState({ showmember: false, showdetails: true, showsroles: false });
  };

  addGroup = () => {
    if (this.state.newgroupname.trim() != "") {
      this.setState({ newgroupnameerror: "" });
      let data = {
        groupName: this.state.newgroupname,
        groupDescription: this.state.description,
      };
      this.props
        .dispatch(AddGroup(data))
        .then((res) => {
          console.log(res);
          this.customToast("Group created successfully");

          this.setState({
            newgroupname: "",
            description: "",
            normalData: [],
          });
          let data = {
            sortBy: this.state.filters.SortBy,
            sortByOrder: this.state.filters.sortByOrder,
            pageNumber: this.state.filters.pageNumber,
            pageSize: this.state.filters.PageSize,
            application: this.state.filters.application,
            subscriptionStatus: this.state.filters.subscriptionStatus,
          };
          this.getAllApplicationData(data, false, true);
          this.closeGroupForm();
        })
        .catch((error) => {
          if (
            error?.response?.data?.message?.trim() ==
            "Group is already exists in this tenant"
          ) {
            this.customToast("Group already exists.");
          }
        });
    } else {
      this.setState({ newgroupnameerror: "Group name is missing" });
    }
  };

  allApicalls = () => {
    this.props.dispatch(AssignedMembers(this.state.groupId)).then((res) => {
      this.setState({
        assignedGroupMembers: res.data,
        totalPages: res.pagination.totalPages,
        totalCount: res.pagination.totalCount,
        currentPage: res.pagination.currentPage,
      });
    });
    this.props.dispatch(UnAssignedMembers(this.state.groupId)).then((res) => {
      this.setState({ unAssignedUsers: res.data });
    });
  };
  allApicalls1 = () => {
    this.handleDataFetch(
      this.state.pageSize,
      this.state.pageIndex,
      this.state.columnFilter,
      this.state.sortingFilters
    );
    this.props.dispatch(UnAssignedMembers(this.state.groupId)).then((res) => {
      this.setState({ unAssignedUsers: res.data });
    });
  };

  savetable = () => {
    debugger;
    const { selectedUserID, selectedUserEmails, groupId } = this.state;

    let data = selectedUserID.map((id, index) => ({
      userId: id,
      email: selectedUserEmails[index],
    }));
    if (data.length > 0) {
      this.setState({ memberError: false });
      this.closeUserGroupForm();

      this.props.dispatch({ type: "IS_LOADER", data: true });
      this.props
        .dispatch(AddMemberInGroup(groupId, data))
        .then((res) => {
          console.log("Response:", res);
          this.allApicalls();
          let data = {
            sortOrder: this.state.filters.sortByOrder,
            sortBy: this.state.filters.SortBy,
          };

          this.getAllApplicationData1(data);
          this.setState({
            selectedUserID: [],
            selectedUserEmails: [],
            selectedUser: null,
            selecteduserssss: [], // Clear selected users in the state
          });
          this.props.dispatch({ type: "IS_LOADER", data: false });
          this.customToast("User(s) added successfully");
        })
        .catch((error) => {
          this.props.dispatch({ type: "IS_LOADER", data: false });
          console.error("Error adding users:", error);
          this.customToast("Error adding user(s)");
        });
    } else {
      this.setState({ memberError: true });
    }
  };
  cancel = () => {
    this.setState({
      selecteduserssss: [],
      description: "", // Clear selected users in the state
    });
  };

  handleUserChange = (event, newValue) => {
    debugger;
    console.log(newValue);

    if (Array.isArray(newValue) && newValue.length >= 0) {
      const existingEmails = new Set(this.state.selectedUserEmails);
      const existingIDs = new Set(this.state.selectedUserID);
      const updatedEmails = [];
      const updatedIDs = [];
      const updatedUserss = [];

      newValue.forEach((user) => {
        console.log("Adding user:", user);
        updatedEmails.push(user.email);
        updatedIDs.push(user.userId);
        updatedUserss.push("");
        existingEmails.add(user.email);
      });

      this.setState((prevState) => ({
        selectedUserEmails: [...updatedEmails],
        selectedUserID: [...updatedIDs],
        selectedUserss: [...updatedUserss],
        selectedUser: newValue, // Update selected users
        selecteduserssss: newValue, // Ensure `selecteduserssss` is updated correctly
      }));
    }
  };

  noAction = () => {
    this.setState({
      opendialogun: false,
    });
  };

  yesAction = () => {
    this.setState({
      opendialogun: false,
    });
    this.props.dispatch(DeleteGroup(this.state.groupId)).then((res) => {
      this.allApicalls();
      let data = {
        sortBy: this.state.filters.SortBy,
        sortByOrder: this.state.filters.sortByOrder,
        pageNumber: this.state.filters.pageNumber,
        pageSize: this.state.filters.PageSize,
        application: this.state.filters.application,
        subscriptionStatus: this.state.filters.subscriptionStatus,
      };
      this.setState({ normalData: [] });
      this.getAllApplicationData(data, false, true);
      this.customToast("Group Deleted");
      this.closeForm();
    });
  };

  deleteGroup = () => {
    this.setState({
      opendialogun: true,
    });
  };

  toggleWebFilter = () => {
    let myOffcanvas = new window.bootstrap.Offcanvas(
      document.getElementById("FilterScreen1")
    );
    myOffcanvas.show();
    $("body").addClass("scrollhide");
    $(".main-content").addClass("scrollhide");
    this.setState({});
  };

  closeWebFilter = () => {
    $("#FilterScreen1").removeClass("show");
    $("body").removeClass("scrollhide");
    $(".main-content").removeClass("scrollhide");
    this.setState({ rows: [] });
    this.setState({
      choice: {
        groupName: "",
      },
    });
  };
  closeWebFilter1 = () => {
    $("#FilterScreen1").removeClass("show");
    $("body").removeClass("scrollhide");
    $(".main-content").removeClass("scrollhide");
    this.setState({ rows: [] });
  };
  lookupChange = (e, selectedValue, title) => {
    if (title === "groupName") {
      this.setState({
        choice: { ...this.state.choice, groupName: e.target.value },
      });
    }
    if (title === "name") {
      this.setState({
        choice: { ...this.state.choice, name: e.target.value },
      });
    }
    if (title === "email") {
      this.setState({
        choice: { ...this.state.choice, email: e.target.value },
      });
    }
  };

  applyFilter = () => {
    const { choice, filters } = this.state;

    // Convert purchasedDate to ISO format if it's not empty
    const purchasedDate = choice.purchasedDate
      ? new Date(choice.purchasedDate).toISOString()
      : null;

    const data = {
      sortBy: filters.SortBy.toLowerCase(),
      sortByOrder: filters.sortByOrder,
      limit: 15,
      offset: 0,
      groupName: choice.groupName.trim(),
    };
    console.log(data);

    this.setState(
      (prevState) => ({
        filters: {
          ...prevState.filters,
          groupName: choice.groupName,
        },
        normalData: [],
        groupedData: {},
        groupedColumn: null,
        filtered: data,
        isGroupBy: true,
        tableLoader: true,
      }),
      () => {
        if (this.state.choice.groupName.trim() !== "") {
          this.setState({ isFilterApplied: true });
        } else {
          this.setState({ isFilterApplied: false });
        }
        this.getAllApplicationData(data);
        this.closeWebFilter1();
      }
    );
  };
  clearFilter = () => {
    this.setState(
      (prevState) => ({
        filters: {
          ...prevState.filters,
          groupName: "",
        },
        choice: {
          ...prevState.choice,
          groupName: "",
        },
        isFilterApplied: false,
        normalData: [],
        groupedData: {},
        groupedColumn: null,
        filtered: {
          sortBy: prevState.filters.SortBy.toLowerCase(),
          sortByOrder: prevState.filters.sortByOrder,
          limit: 15,
          offset: 0,
          groupName: "",
        },
        isGroupBy: true,
      }),
      () => {
        const data = {
          sortBy: this.state.filters.SortBy.toLowerCase(),
          sortByOrder: this.state.filters.sortByOrder,
          limit: 15,
          offset: 0,
        };

        this.getAllApplicationData(data, true);
        this.closeWebFilter();
      }
    );
  };

  applyRoleFilter = () => {
    debugger;
    const { choice, filters } = this.state;

    let data = {
      Name: choice.name,
      Email: choice.email,

      SortBy: filters.SortBy,
      SortOrder: filters.sortByOrder,
      PageNumber: 1,
      PageSize: 10,
    };
    console.log(data);

    this.setState(
      (prevState) => ({
        filters: {
          ...prevState.filters,
          application: choice.application,
          subscriptionStatus: choice.subscriptionStatus,
          purchasedDate: choice.purchasedDate,
        },
        filterOptions: {
          ...prevState.filterOptions,
          name: choice.name,
          email: choice.email,
        },

        groupedData: {},
        groupedColumn: null,
        filtered: data,
        isGroupBy: true,
        tableLoader: true,
      }),
      () => {
        if (this.state.choice?.name || this.state.choice?.email) {
          this.setState({ isFilterAppliedRole: true });
        } else {
          this.setState({ isFilterAppliedRole: false });
        }
        this.props
          .dispatch(AssignedMembers(this.state.groupId, data))
          .then((res) => {
            this.setState((prev) => ({
              assignedGroupMembers: res.data,
              totalPages: res.pagination.totalPages,
              totalCount: res.pagination.totalCount,
              currentPage: res.pagination.currentPage,
              filters: {
                ...prev.filters,
                PageSize: res.pagination.pageSize,
              },
            }));
            this.closeWebFilterMember();
          });
      }
    );
  };
  applyRoleFilterName = () => {
    const { choice, filters } = this.state;

    let data = {
      Name: "",
      Email: choice.email,

      SortBy: filters.SortBy,
      SortOrder: filters.sortByOrder,
      PageNumber: 1,
      PageSize: 10,
    };
    console.log(data);

    this.setState(
      (prevState) => ({
        filters: {
          ...prevState.filters,
          application: choice.application,
          subscriptionStatus: choice.subscriptionStatus,
          purchasedDate: choice.purchasedDate,
        },
        filterOptions: {
          ...prevState.filterOptions,
          name: "",
          email: choice.email,
        },
        choice: {
          ...prevState.choice,
          name: "",
        },

        groupedData: {},
        groupedColumn: null,
        filtered: data,
        isGroupBy: true,
        tableLoader: true,
      }),
      () => {
        debugger;
        if (this.state.choice?.name || this.state.choice?.email) {
          this.setState({ isFilterAppliedRole: true });
        } else {
          this.setState({ isFilterAppliedRole: false });
        }
        this.props
          .dispatch(AssignedMembers(this.state.groupId, data))
          .then((res) => {
            this.setState((prev) => ({
              assignedGroupMembers: res.data,
              totalPages: res.pagination.totalPages,
              totalCount: res.pagination.totalCount,
              currentPage: res.pagination.currentPage,
              filters: {
                ...prev.filters,
                PageSize: res.pagination.pageSize,
              },
            }));
            this.closeWebFilterMember();
          });
      }
    );
  };
  applyRoleFilterEmail = () => {
    const { choice, filters } = this.state;

    let data = {
      Name: choice.name,
      Email: "",

      SortBy: filters.SortBy,
      SortOrder: filters.sortByOrder,
      PageNumber: 1,
      PageSize: 10,
    };
    console.log(data);

    this.setState(
      (prevState) => ({
        filters: {
          ...prevState.filters,
          application: choice.application,
          subscriptionStatus: choice.subscriptionStatus,
          purchasedDate: choice.purchasedDate,
        },
        filterOptions: {
          ...prevState.filterOptions,
          name: choice.name,
          email: "",
        },
        choice: {
          ...prevState.choice,
          email: "",
        },

        groupedData: {},
        groupedColumn: null,
        filtered: data,
        isGroupBy: true,
        tableLoader: true,
      }),
      () => {
        if (this.state.choice.name || this.state.choice.email) {
          this.setState({ isFilterAppliedRole: true });
        } else {
          this.setState({ isFilterAppliedRole: false });
        }
        this.props
          .dispatch(AssignedMembers(this.state.groupId, data))
          .then((res) => {
            this.setState((prev) => ({
              assignedGroupMembers: res.data,
              totalPages: res.pagination.totalPages,
              totalCount: res.pagination.totalCount,
              currentPage: res.pagination.currentPage,
              filters: {
                ...prev.filters,
                PageSize: res.pagination.pageSize,
              },
            }));
            this.closeWebFilterMember();
          });
      }
    );
  };

  clearRoleFilter = () => {
    this.setState(
      (prevState) => ({
        filters: {
          ...prevState.filters,
          application: "",
          subscriptionStatus: 0,
          purchasedDate: null,
          name: "",
          email: "",
          type: "",
        },
        choice: {
          ...prevState.choice,
          name: "",
          email: "",
        },
        filterOptions: {
          ...prevState.filteredOptions,
          name: "",
          email: "",
        },

        groupedData: {},
        groupedColumn: null,
        filtered: {
          SortBy: prevState.filters.SortBy,
          sortByOrder: prevState.filters.sortByOrder,
          limit: 15,
          offset: 0,
          application: "",
          subscriptionStatus: 0,
          purchasedDate: null,
        },
        isGroupBy: true,
      }),
      () => {
        const data = {
          Name: "",
          Email: "",
          Type: "",
          SortBy: "",
          SortOrder: "",
          PageNumber: "",
          PageSize: "",
        };
        this.setState({ isFilterAppliedRole: false });

        this.props
          .dispatch(AssignedMembers(this.state.groupId, data))
          .then((res) => {
            this.setState({
              assignedGroupMembers: res.data,
              totalPages: res.pagination.totalPages,
              totalCount: res.pagination.totalCount,
              currentPage: res.pagination.currentPage,
            });
            this.closeWebFilterMember1();
          });
      }
    );
  };

  newUserGroupFormShow = () => {
    console.log("helllllp");

    let myOffcanvas = new window.bootstrap.Offcanvas(
      document.getElementById("AddGroupmain")
    );
    this.setState({ memberError: false });
    this.setState((prevState) => ({
      selectedUserEmails: [],
      selectedUserID: [],
      selectedUserss: [],
      selectedUser: [], // Update selected users
      selecteduserssss: [], // Ensure `selecteduserssss` is updated correctly
    }));
    myOffcanvas.show();
    $("body").addClass("scrollhide");
    $(".main-content").addClass("scrollhide");
    this.setState({
      backdrop: true,
    });
  };
  closeUserGroupForm = () => {
    $("#AddGroupmain").removeClass("show");
    $(".offcanvas-backdrop").removeClass("show");
    $("body").removeClass("scrollhide");
    $(".main-content").removeClass("scrollhide");
    let data = {
      sortBy: this.state.filters.SortBy,
      sortByOrder: this.state.filters.sortByOrder,
      pageNumber: this.state.filters.pageNumber,
      pageSize: this.state.filters.PageSize,
      application: this.state.filters.application,
      subscriptionStatus: "Subscribed",
    };

    this.setState((prevState) => ({
      selectedUserEmails: [],
      selectedUserID: [],
      selectedUserss: [],
      selectedUser: [], // Update selected users
      selecteduserssss: [], // Ensure `selecteduserssss` is updated correctly
    }));
    // this.getAllApplicationData(data, false, true)
    this.setState({
      selectedItem: {
        availableLicenses: 0,
      },
      selecteduserssss: [],
      backdrop: false,
      isAddingResource: false,
      selectedRoleId: null,
      isEditing: false,
    });
  };
  toggleWebFilterMember = () => {
    console.log("filter");
    let myOffcanvas = new window.bootstrap.Offcanvas(
      document.getElementById("FilterScreenroles")
    );
    myOffcanvas.show();
    $("body").addClass("scrollhide");
    $(".main-content").addClass("scrollhide");
    this.setState({});
  };
  closeWebFilterMember = () => {
    $("#FilterScreenroles").removeClass("show");
    $("body").removeClass("scrollhide");
    $(".main-content").removeClass("scrollhide");
    this.setState({ rows: [] });
    // this.setState({
    //     choice: {
    //         groupName: "",

    //     },
    // });
  };
  closeWebFilterMember1 = () => {
    $("#FilterScreenroles").removeClass("show");
    $("body").removeClass("scrollhide");
    $(".main-content").removeClass("scrollhide");
    this.setState({ rows: [] });
    this.setState({
      choice: {
        groupName: "",
      },
    });
  };

  handlePagePerPage = (value) => {
    console.log(value);

    this.setState(
      (prevState) => ({
        filters: {
          ...prevState.filters,
          PageSize: value,
        },

        groupedData: {},
        groupedColumn: null,
        filtered: data,
        tableLoader: true,
      }),
      () => {
        let data = {
          PageSize: value,
          PageNumber: this.state.filters.pageNumber,
        };
        this.props
          .dispatch(AssignedMembers(this.state.groupId, data))
          .then((res) => {
            this.setState({
              assignedGroupMembers: res.data,
              totalPages: res.pagination.totalPages,
              totalCount: res.pagination.totalCount,
              currentPage: res.pagination.currentPage,
            });
            this.closeWebFilter();
          });
      }
    );
  };
  handlePagination = (newPage) => {
    console.log("New Page:", newPage);
    // this.state.filters.pageNumber=newPage;
    this.setState(
      (prevState) => ({
        filters: {
          ...prevState.filters,
          pageNumber: newPage,
        },

        groupedData: {},
        groupedColumn: null,
        filtered: data,
        tableLoader: true,
      }),
      () => {
        let data = {
          PageSize: this.state.filters.PageSize,
          PageNumber: newPage,
        };
        this.props
          .dispatch(AssignedMembers(this.state.groupId, data))
          .then((res) => {
            this.setState({
              assignedGroupMembers: res.data,
              totalPages: res.pagination.totalPages,
              totalCount: res.pagination.totalCount,
              currentPage: res.pagination.currentPage,
            });
            this.closeWebFilter();
          });
      }
    );
  };
  handlegroupchnage = (element) => {
    this.closeUserGroupForm();
    this.cancelGroup();
    debugger;
    this.setState(
      {
        groupName: element.groupName,
        choice: {
          application: "",
          subscriptionStatus: 0,
          purchasedDate: null,
          groupName: "",
          name: "",
          email: "",
        },
      },
      () => {
        console.log(this.state.choice);
      }
    );
    this.setState({ editGroup: false });
    this.handleEditId(
      element.groupId,
      element.groupName,
      element.description,
      element.totalMembers
    );
  };

  editGroup = () => {
    this.setState({
      editGroup: true,
      newgroupname: this.state.groupName,
      description: this.state.description,
      tempDescription: this.state.description,
    });
  };
  cancelGroup = () => {
    this.setState({
      editGroup: false,
      newgroupnameerror: "",
      description: this.state.tempDescription,
    });
  };

  updateGroup = () => {
    if (this.state.newgroupname.trim() != "") {
      this.setState({ newgroupnameerror: "" });
      let data = {
        groupName: this.state.newgroupname,
        groupDescription: this.state.description,
      };
      this.props
        .dispatch(GroupEdit(this.state.groupId, data))
        .then((res) => {
          this.customToast("Updated successfully.");
          let data = {
            sortOrder: this.state.filters.sortByOrder,
            sortBy: this.state.filters.SortBy,
          };
          this.getAllApplicationData1(data);
          this.setState({
            groupName: this.state.newgroupname,
            description: this.state.description,
            editGroup: false,
          });
        })
        .catch((error) => {
          this.setState({ isLoader: false });
          if (
            error?.response?.data?.message?.trim() ==
            "Group is already exists in this tenant"
          ) {
            this.customToast("Group already exists.");
          }
        });
    } else {
      this.setState({ newgroupnameerror: "Group name is missing" });
    }
  };
  resize = () => {
    if (window.innerWidth < 850) {
      this.setState({
        isMobile: true,
      });
    } else {
      this.setState({
        isMobile: false,
        isWebMobile: false,
      });
    }

    if (window.innerWidth < 468) {
      this.setState({
        isMobile600: true,
        isWebMobile: true,
      });
    } else {
      this.setState({
        isMobile600: false,
        isWebMobile: false,
      });
    }

    if (window.innerWidth < 380) {
      this.setState({
        isMobile380: true,
      });
      this.setState({
        isMobile380: true,
      });
    } else {
      this.setState({
        isMobile380: false,
      });
    }
    this.setState({
      height: window.innerHeight,
    });
  };

  detailsmobile = () => {
    this.closeUserGroupForm();
    this.setState({ showmember: false, showdetails: true, showsroles: false });
    this.newFormdetailsShow();
  };
  newFormdetailsShow = () => {
    const offcanvasElement = document.getElementById("groupdetails");

    if (offcanvasElement && offcanvasElement.classList.contains("show")) {
      console.log("Offcanvas is already open.");
      return; // Exit the function if Offcanvas is already open
    }
    let myOffcanvas = new window.bootstrap.Offcanvas(offcanvasElement);
    myOffcanvas.show();

    $("body").addClass("scrollhide");
    $(".main-content").addClass("scrollhide");

    this.setState({
      backdrop: true,
    });
  };

  closegroupdetails = () => {
    $("#groupdetails").removeClass("show");
    // $(".offcanvas-backdrop").removeClass("show");
    $("body").removeClass("scrollhide");
    $(".main-content").removeClass("scrollhide");
    this.setState({ rows: [] });
    this.setState({
      editGroup: false,
      choice: {
        groupName: "",
      },
    });
  };
  newFormmembersShow = () => {
    const offcanvasElement = document.getElementById("groupmembers");

    if (offcanvasElement && offcanvasElement.classList.contains("show")) {
      console.log("Offcanvas is already open.");
      return; // Exit the function if Offcanvas is already open
    }
    let myOffcanvas = new window.bootstrap.Offcanvas(offcanvasElement);
    myOffcanvas.show();

    $("body").addClass("scrollhide");
    $(".main-content").addClass("scrollhide");

    this.setState({
      backdrop: true,
    });
  };

  closegroupmembers = () => {
    $("#groupmembers").removeClass("show");
    $("body").removeClass("scrollhide");
    $(".main-content").removeClass("scrollhide");
    this.setState({ rows: [] });
    // this.setState({
    //     choice: {
    //         groupName: "",
    //     },
    // });
  };

  membersmobile = () => {
    this.setState({ showmember: true, showdetails: false, showsroles: false });
    this.setState({
      pageSize: 10,
      pageIndex: 0,
      columnsFilters: [],
      sortingFilters: [],
    });
    this.members1();
    this.newFormmembersShow();
  };
  render() {
    const { isWebMobile, isMobile } = this.state;
    return (
      <>
        <ToastContainer position="top-right" />
        {!isWebMobile && !isMobile ? (
          <div className="mainSetting">
            <div className="content-header mb-2">
              <Backdrop className="spinner-backdrop">
                <CircularProgress color="primary" />
              </Backdrop>
              <div className="w-100 ">
                <div className="row tapbar" style={{ paddingRight: "2rem" }}>
                  <div className="col-5 col-lg-5 col-sm-6 col-md-6 ">
                    <span className="headerform">Groups</span>
                  </div>
                  <div className="col-lg-7 col-sm-6 col-md-6 col-lg-6 d-flex justify-content-end">
                    <div className="btn-container">
                      <button
                        className=" btn-fun btn-new fs-7"
                        type="button"
                        onClick={this.newGroupFormShow}
                      >
                        <CommonIcon fileName={"AddPlus"} />
                        Add Group
                      </button>{" "}
                      <button
                        className=" btn-funno fs-7 ps-3 pe-3"
                        type="button"
                        onClick={this.toggleWebFilter}
                      >
                        <CommonIcon
                          fileName={
                            this.state.isFilterApplied ? "Filtered" : "Filter"
                          }
                        />
                      </button>{" "}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {this.state.choice.groupName && this.state.isFilterApplied && (
              <>
                <div className="pe-1 mt-0 mb-1">
                  <span className={"filteredBadge"}>
                    <span>Group Name</span>
                    <span
                      className="ms-2 cursor-pointer"
                      onClick={this.clearFilter}
                    >
                      <CommonIcon fileName={"CloseSmallwhite"} />
                    </span>
                  </span>
                </div>
                <p className="mb-0 mt-2 countValue">
                  Count: {this.state.normalData.length}
                </p>
              </>
            )}
            <div className="groupcard" style={{ marginRight: "2rem" }}>
              {this.state.normalData.length < 1 && !this.state.isloading ? (
                <div className="card sharpcorner1  cursor-pointer px-2 my-2 mt-2 p-2">
                  <div className="card-body">
                    <div
                      style={{
                        position: "absolute",
                        left: "0",
                        top: "-0.1px",
                        bottom: "-0.2px",
                        width: "4px",
                        backgroundColor: " rgb(33, 150, 243)",
                      }}
                    ></div>
                    <div className="row">
                      <div className="col-lg-12 col-md-5 col-5 d-flex align-items-center">
                        <div className="row text-center w-100">
                          <div className="col-12">
                            <span
                              className="nofound "
                              style={{ fontWeight: "bold" }}
                            >
                              No groups found
                            </span>
                          </div>
                          {/* <div className="col-12"><span className="reporttext12" style={{ fontWeight: "bold" }}>{}</span></div> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                this.state.normalData.map((element, inde) => {
                  return (
                    <div
                      className="card sharpcorner1  cursor-pointer px-2 my-2 mt-2 "
                      onClick={() =>
                        this.handleEditId(
                          element.groupId,
                          element.groupName,
                          element.description,
                          element.totalMembers
                        )
                      }
                    >
                      <div className="card-body">
                        <div
                          style={{
                            position: "absolute",
                            left: "0",
                            top: "-0.1px",
                            bottom: "-0.2px",
                            width: "4px",
                            backgroundColor: " rgb(33, 150, 243)",
                          }}
                        ></div>
                        <div className="row">
                          <div className="col-lg-4 col-md-12 col-sm-12 d-flex align-items-center">
                            <div className="row">
                              <div className="col-12">
                                <span
                                  className="reporttext14"
                                  style={{ fontWeight: "bold" }}
                                >
                                  {element.groupName}
                                </span>
                              </div>
                              {/* <div className="col-12"><span className="reporttext12" style={{ fontWeight: "bold" }}>{}</span></div> */}
                            </div>
                          </div>
                          <div className="col-lg-2 col-md-4 col-12 d-flex align-items-center">
                            <div className="row ">
                              <div className="col-12">
                                <span className="reporttext14">
                                  Total Members
                                </span>
                              </div>
                              <div className="col-12">
                                <span className="reporttext12">
                                  {element.totalMembers}
                                </span>
                              </div>
                            </div>
                          </div>
                          <div className="col-lg-5 col-md-6 col-12 d-flex align-items-center">
                            <div className="row desc">
                              <div className="col-12">
                                <span className="reporttext14">
                                  Description
                                </span>
                              </div>
                              <div className="col-12">
                                <span className="reporttext12desc">
                                  {" "}
                                  {element.description &&
                                  element.description.length > 70
                                    ? `${element.description.substring(
                                        0,
                                        70
                                      )}...`
                                    : element.description || "-"}
                                </span>
                              </div>
                            </div>
                          </div>

                          <div className="col-lg-1 col-md-2 col-0 d-flex align-items-center justify-content-end">
                            <div className="row ">
                              <CommonIcon
                                className="float-end"
                                fileName={"Arrownext"}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })
              )}
            </div>
            {/* <div
                            className="offcanvas offcanvas-end p-3 pt-0 ps-0 pb-0"
                            data-bs-scroll="false"
                            data-bs-backdrop
                            id="AddForm2"
                            aria-labelledby="offcanvasScrollingLabel"
                            style={{
                                width: "calc(100%)",

                                height: '100vh',

                            }}
                        >
                            <div className='d-flex align-items-start w-100'>
                                <div className='leftgrouppanel'>
                                    <div className='leftsidepanel w-100'>
                                        <div className='d-flex justify-content-between ps-3  pb-1 wholeheader1'>
                                            <h3 className='headername1'>Groups</h3>
                                        </div>
                                        <div className='leftpanel1 pb-1'>
                                            <ul className='leftpanelulgroup'>
                                                {this.state.normalData.map((e) => {
                                                    return <li className={`${this.state.groupName === e.groupName ? "leftpanelli" : "leftpanelli1"}`} onClick={() => this.handlegroupchnage(e)}>{e.groupName}</li>
                                                })}
                                            </ul>
                                        </div>
                                    </div>
                                    <ul>

                                    </ul>
                                </div>


                                <div className='d-flex align-items-start w-100'>
                                    <div className='leftsidepanelattr'>
                                        <div className='d-flex justify-content-between ps-3 pb-1 wholeheader1'>
                                            <h3 className={`${this.state.groupName.length < 20 ? "headername1" : "lowerheadername"}`}
                                                style={{
                                                    whiteSpace: 'nowrap',
                                                    overflow: 'hidden',
                                                    textOverflow: 'ellipsis',
                                                    width: '200px' 
                                                }}>
                                                <Tooltip title={this.state.groupName}>
                                                    <span>{this.state.groupName}</span>
                                                </Tooltip>
                                            </h3>
                                        </div>
                                        <div className='leftpanel1 pb-1'>
                                            <ul className='leftpanelulgroup'>
                                                <li className={`d-flex align-items-center ${this.state.showdetails ? "leftpanelli " : "leftpanelli1"}`} onClick={this.details}><CommonIcon fileName={'idcardicon'} />&nbsp;&nbsp;Details</li>
                                                <li className={`d-flex align-items-center ${this.state.showmember ? "leftpanelli" : "leftpanelli1"}`} onClick={this.members} ><CommonIcon fileName={'groupicon'} />&nbsp;&nbsp;Members</li>
                                            </ul>
                                        </div>
                                    </div>




                                    <div className='w-100'>

                                        {this.state.showmember &&
                                            <div className='w-100 p-3 pt-1 height100'>

                                                <div className='d-flex justify-content-between ps-1 pt-1  pb-1'>
                                                    <h3 className='headername1 pt-1'>Members</h3>
                                                    <div className='d-flex justify-content-end pb-2 pe-1 pt-2'>
                                                        <button className='btn-fun btn-new fs-7 me-2' onClick={this.newUserGroupFormShow}><CommonIcon fileName={'AddPlus'} />Add</button>
                                                        <button
                                                            data-bs-dismiss="offcanvas"
                                                            className="offcavasclose float-end mt--10 pe-0"
                                                            onClick={() => this.closeForm()}
                                                        >
                                                            <CommonIcon fileName={"Close"} />
                                                        </button>
                                                    </div>

                                                </div>


                                                <div className='ps-2 mt-2' style={{ width: "100%" }}>
                                                    <CustomListView
                                                        listData={this.state.assignedGroupMembers ?? []}
                                                        columns={this.state.columns}
                                                        handleDataFetch={this.handleDataFetch}
                                                        totalCount={this.state.totalCount}
                                                        isLoading={this.state.tableLoader}
                                                    />
                                                </div>
                                            </div>}
                                        {this.state.showdetails &&
                                            <div className=''>
                                                <div className='d-flex justify-content-between ps-3 pb-1 pt-2'>
                                                    <h3 className='headername1'>Details</h3>
                                                    <button
                                                        data-bs-dismiss="offcanvas"
                                                        className="offcavasclose float-end "
                                                        onClick={() => this.closeForm()}
                                                    >
                                                        <CommonIcon fileName={"Close"} />
                                                    </button>
                                                </div>

                                                <div className=' p-4 pe-0 pt-1 w-100'>
                                                    <div className="row p-4 ps-2 pt-2 pe-1 ">
                                                        <div className='col-3 ps-1'>
                                                            <h3 className='licenseheader'>Group details</h3>
                                                        </div>
                                                        <div className={`col-9 ${this.state.editGroup ? '' : 'pe-0'}`}>
                                                            <div className={`row d-flex pe-0 ${!this.state.editGroup ? 'w-100' : ''}`}>
                                                                <div className={!this.state.editGroup ? 'col-10' : 'col-12'}>
                                                                    <div className='d-flex'><FormLabel className="formlabel-style1">Group Name </FormLabel> {!this.state.editGroup ? <> <span className='px-3'>-</span><span className={`formlabel-input`}>{this.state.groupName}</span></> : ""}</div>
                                                                    {this.state.editGroup ? <> <TextField
                                                                        error={this.state.newgroupnameerror}
                                                                        id='email'
                                                                        fullWidth
                                                                        className={`filter_input br-4 }`}
                                                                        variant="filled"
                                                                        value={this.state.newgroupname}
                                                                        onChange={(e) => { this.setState({ newgroupname: e.target.value }) }}
                                                                        focused
                                                                    />
                                                                        {this.state.newgroupnameerror && (
                                                                            <div className="error-message" style={{ color: 'red' }}>
                                                                                {this.state.newgroupnameerror}
                                                                            </div>
                                                                        )}
                                                                    </>
                                                                        : ""}
                                                                </div>
                                                                {!this.state.editGroup &&
                                                                    <div className='col-2 pe-0'>
                                                                        {!this.state.editGroup ?
                                                                            <span className="isedit cursor-pointer float-end " onClick={this.editGroup}><CommonIcon fileName={'editicon'} /></span>
                                                                            : ""}
                                                                    </div>
                                                                }

                                                            </div>
                                                            <div className="col-12 mt-3">
                                                                <div className='d-flex'><FormLabel className="formlabel-style1">Total members </FormLabel><span className={`formlabel-input `}><span className='px-3'>-</span>{this.state.totalMembers}</span></div>
                                                            </div>
                                                            <div className="col-12 mt-3">                                                                <div className='d-flex align-items-start'><FormLabel className="formlabel-style1">Description   </FormLabel></div>{!this.state.editGroup ? <><div className='text-justify  pe-2'> <span className={`formlabel-input text-justify `}>{this.state.description}</span></div> </> : ""}
                                                                
                                                                {this.state.editGroup ? <TextareaAutosize
                                                                    id='description'
                                                                    className={`filter_input br-4 }`}

                                                                    variant="filled"
                                                                    value={this.state.description}
                                                                    onChange={(e) => this.setState({ description: e.target.value })}
                                                                    focused
                                                                    minRows={5}
                                                                    style={{ width: "100%", paddingLeft: '13px' }}
                                                                /> : ""}
                                                            </div>

                                                            {!this.state.editGroup ? <div className="col-4 mb-3 mt-3">
                                                                <span className="unsubscribe cursor-pointer ps-3 pe-3" onClick={this.deleteGroup}>Delete</span>
                                                            </div> : ""}
                                                            {this.state.editGroup ? <div className='col-12 pb-20 pr-28 mt-2'>
                                                                <button className={`btn-cancel btn-filter-action border-none ms-1`} variant="outlined" onClick={this.cancelGroup}>Cancel</button>
                                                                <button className={`btn-fun btn-action btn-filter-action`} variant="primary" onClick={this.updateGroup}>Save</button>

                                                            </div> : ""}
                                                        </div>


                                                    </div>

                                                </div>

                                            </div>}
                                        {this.state.showsroles &&
                                            <div><h3>ROLES ASSIGN</h3></div>
                                        }
                                    </div>
                                </div>
                            </div>

                        </div> */}

            <div
              className="offcanvas offcanvas-end"
              tabIndex={-1}
              data-bs-scroll="false"
              data-bs-backdrop="true"
              id="AddGroup"
              aria-labelledby="offcanvasScrollingLabel"
            >
              <div className={`offcanvas-header px-4 pt-2 pb-3 mt-10`}>
                <span className="headername1 px-2">Add Group</span>
                <button
                  data-bs-dismiss="offcanvas"
                  className="offcavasclose"
                  onClick={() => this.closeGroupForm()}
                >
                  <CommonIcon fileName={"Close"} />
                </button>
              </div>

              <div
                className="offcanvas-body px-4 pt-0"
                style={{ overflow: "hidden" }}
              >
                <div className="row ps-3" style={{ padding: "0rem 0rem" }}>
                  <div className="col-12  flex-1">
                    <FormLabel
                      className="formlabel-style w-100"
                      id="first-name-label"
                    >
                      Group Name<span className={`isrequired`}>*</span>
                    </FormLabel>

                    <TextField
                      error={this.state.newgroupnameerror}
                      id="email"
                      className={`filter_input br-4 }`}
                      // fullWidth label="First Name"
                      variant="filled"
                      value={this.state.newgroupname}
                      onChange={(e) => {
                        this.setState({ newgroupname: e.target.value });
                      }}
                      focused
                      style={{ width: "96%" }}
                    />

                    {this.state.newgroupnameerror && (
                      <div className="error-message" style={{ color: "red" }}>
                        {this.state.newgroupnameerror}
                      </div>
                    )}
                  </div>
                  <div className={`col-12 mt-3 flex-1`}>
                    <FormLabel
                      className="formlabel-style w-100"
                      id="first-name-label"
                    >
                      Description
                    </FormLabel>
                    <TextareaAutosize
                      // error={this.state.lastNameError}
                      id="description"
                      className={`filter_input br-4 }`}
                      // fullWidth label="First Name"
                      variant="filled"
                      value={this.state.description}
                      onChange={(e) =>
                        this.setState({ description: e.target.value })
                      }
                      focused
                      minRows={5}
                      style={{ width: "96%", paddingLeft: "13px" }}
                    />

                    {/* {this.state.lastNameError && (
                          <div className="error-message" style={{ color: 'red' }}>
                            {this.state.lastNameErrorMessage}
                          </div>
                        )} */}
                  </div>
                </div>
                <p class="ml-12" />
                <div className="row mt-2">
                  <div className="col-12 pb-20 pr-28 ml-16">
                    {/* <button data-bs-dismiss="offcanvas" className={`btn-cancel btn-filter-action border-none ms-1`} variant="outlined" onClick={() => this.closeForm()}>Cancel</button> */}
                    <button
                      className={`btn-fun btn-action btn-filter-action`}
                      variant="primary"
                      onClick={() => this.addGroup()}
                    >
                      Add
                    </button>
                  </div>
                </div>

                <div>
                  <div className={`col-12 `}></div>
                </div>
              </div>
            </div>
            <div
              className="offcanvas offcanvas-end"
              data-bs-scroll="false"
              data-bs-backdrop="false"
              id="FilterScreen1"
              aria-labelledby="offcanvasScrollingLabel"
            >
              <div className={`offcanvas-header px-4 pt-4 pb-3 mt-10`}>
                <h6
                  id="offcanvasRightLabel"
                  className="modal-title head-span"
                  style={{ fontWeight: "600" }}
                >
                  Filterss
                </h6>
                <button
                  className="offcavasclose"
                  onClick={() => this.closeWebFilter1()}
                >
                  <CommonIcon fileName={"Close"} />
                </button>
              </div>

              <div className="offcanvas-body ps-4 pe-4 pt-0">
                <div className="row">
                  <div
                    className="row"
                    style={{
                      padding: "1rem",
                      paddingTop: "0",
                      paddingRight: "0px",
                    }}
                  >
                    <div className={`col-12 mt-2 pe-2`}>
                      <TextField
                        id="jobOpTitle"
                        className="filter_input"
                        fullWidth
                        label="Group Name"
                        variant="filled"
                        value={this.state.choice.groupName}
                        onChange={(e) => this.lookupChange(e, "", "groupName")}
                        focused
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="row pe-4">
                <div className="col-12 align_justify_end pb-20 ">
                  <Button
                    className="btn-clear mr-10 border-none"
                    variant="outlined"
                    onClick={() => this.clearFilter()}
                    sx={{
                      textTransform: "nobe",
                      borderRadius: 0, // Set borderRadius to 0 for sharp edges
                      "&:hover": {
                        borderRadius: 0, // Ensure sharp edges on hover as well
                      },
                    }}
                  >
                    Reset
                  </Button>
                  <button
                    className="btn-apply"
                    variant="primary"
                    onClick={() => this.applyFilter()}
                  >
                    Apply
                  </button>
                </div>
              </div>
            </div>
            <div
              className="offcanvas offcanvas-end"
              data-bs-scroll="false"
              data-bs-backdrop="false"
              id="FilterScreenroles"
              aria-labelledby="offcanvasScrollingLabel"
            >
              <div className={`offcanvas-header px-4 pt-4 pb-3 mt-10`}>
                <h6
                  id="offcanvasRightLabel"
                  className="modal-title head-span"
                  style={{ fontWeight: "600" }}
                >
                  Filter
                </h6>
                <button
                  className="offcavasclose"
                  onClick={() => this.closeWebFilterMember()}
                >
                  <CommonIcon fileName={"Close"} />
                </button>
              </div>

              <div className="offcanvas-body px-4 pt-0">
                <div className="row">
                  <div
                    className="row"
                    style={{ padding: "1rem", paddingTop: "0" }}
                  >
                    <div className={`col-12 mt-2`}>
                      <TextField
                        id="jobOpTitle"
                        className="filter_input"
                        fullWidth
                        label="Name"
                        variant="filled"
                        value={this.state.choice.name}
                        onChange={(e) => this.lookupChange(e, "", "name")}
                        focused
                      />
                    </div>
                    <div className={`col-12 mt-2`}>
                      <TextField
                        id="jobOpTitle"
                        className="filter_input"
                        fullWidth
                        label="Email"
                        variant="filled"
                        value={this.state.choice.email}
                        onChange={(e) => this.lookupChange(e, "", "email")}
                        focused
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-12 align_justify_end pb-20 pr-54">
                  <Button
                    className="btn-clear mr-10 border-none"
                    variant="outlined"
                    onClick={() => this.clearRoleFilter()}
                    sx={{
                      borderRadius: 0,
                      textTransform: "none", // This will prevent the text from being transformed to uppercase
                      "&:hover": {
                        borderRadius: 0,
                      },
                    }}
                  >
                    Reset
                  </Button>
                  <button
                    className="btn-apply"
                    variant="primary"
                    onClick={() => this.applyRoleFilter()}
                  >
                    Apply
                  </button>
                </div>
              </div>
            </div>
            <div
              className={`modal modal-style ${
                this.state.opendialogun ? "show" : ""
              }`}
              id="deletemodal"
              tabindex="-1"
              aria-labelledby="exampleModalLabel"
              aria-hidden="true"
              style={{
                display: this.state.opendialogun ? "block" : "none",
                zIndex: "1070",
              }}
            >
              <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content shadow-lg bg-white rounded">
                  <div className="modal-body text-center">
                    <CommonIcon fileName={"deletegroup"} />
                    <br />
                    <span>Are you sure, you want to delete this group?</span>
                  </div>
                  <div className="modal-footer justify-content-center">
                    <Button
                      className="btn-no px-4"
                      variant="primary"
                      onClick={() => this.noAction()}
                    >
                      No
                    </Button>{" "}
                    <Button
                      className="btn-action px-4"
                      variant="primary"
                      onClick={() => this.yesAction()}
                    >
                      Yes
                    </Button>{" "}
                  </div>
                </div>
              </div>
            </div>
            <div
              className={`modal modal-style ${
                this.state.openmemberdelete ? "show" : ""
              }`}
              id="deletemodal"
              tabindex="-1"
              aria-labelledby="exampleModalLabel"
              aria-hidden="true"
              style={{
                display: this.state.openmemberdelete ? "block" : "none",
                zIndex: "1070",
              }}
            >
              <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content shadow-lg bg-white rounded">
                  <div className="modal-body text-center">
                    <CommonIcon fileName={"deletemember"} />
                    <br />
                    <span>
                      Are you sure, you want to delete this member from group?
                    </span>
                  </div>
                  <div className="modal-footer justify-content-center">
                    <Button
                      className="btn-no px-4"
                      variant="primary"
                      onClick={() => this.noActions()}
                    >
                      No
                    </Button>{" "}
                    <Button
                      className="btn-action px-4"
                      variant="primary"
                      onClick={() => this.yesActions()}
                    >
                      Yes
                    </Button>{" "}
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="mobilemain">
            {" "}
            {/* This should handle the mobile version if needed */}
            <Backdrop
              className="spinner-backdrop"
              open={this.props.isLoading1 || this.props.userRoleAssign}
            >
              <CircularProgress color="primary" />
            </Backdrop>
            {/* <ToastContainer /> */}
            {/* Mobile version content */}
            <div className="row">
              {/* <div className="col-12 titlebar-mob"> */}
              {isWebMobile ? (
                <div className="row">
                  <div className="col-2 pe-1">
                    <span
                      className="mobile-menu"
                      onClick={() => this.props.toggleMenu()}
                    >
                      <CommonIcon fileName={"Menu"} />
                    </span>
                  </div>
                  <div className="col-4 ps-0">
                    <span className="headerform-mobile">Groups</span>
                  </div>
                  <div className="col-6 pt-1 float-end">
                    <div className="float-end d-flex">
                      <button
                        className=" btn-fun btn-new fs-7"
                        type="button"
                        onClick={this.newGroupFormShow}
                      >
                        <CommonIcon fileName={"AddPlus"} />
                        Add
                      </button>{" "}
                      <button
                        className=" btn-funno fs-7 ps-3 pe-3"
                        type="button"
                        onClick={this.toggleWebFilter}
                      >
                        <CommonIcon
                          fileName={
                            this.state.isFilterApplied ? "Filtered" : "Filter"
                          }
                        />
                      </button>{" "}
                    </div>
                  </div>
                </div>
              ) : (
                <div className="w-100 pr">
                  <div className="row tapbar" style={{ paddingRight: "2rem" }}>
                    <div className="col-5 col-lg-5 col-sm-6 col-md-6 ps-2">
                      <span className="headerform ps-4">Groups</span>
                    </div>
                    <div className="col-lg-7 col-sm-6 col-md-6 col-lg-6 justify-right pt-2 pe-1">
                      <div className="btn-container">
                        <button
                          className=" btn-fun btn-new fs-7"
                          type="button"
                          onClick={this.newGroupFormShow}
                        >
                          <CommonIcon fileName={"AddPlus"} />
                          Add Group
                        </button>{" "}
                        <button
                          className=" btn-funno fs-7 ps-3 pe-3"
                          type="button"
                          onClick={this.toggleWebFilter}
                        >
                          <CommonIcon
                            fileName={
                              this.state.isFilterApplied ? "Filtered" : "Filter"
                            }
                          />
                        </button>{" "}
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {this.state.choice.groupName && this.state.isFilterApplied && (
                <>
                  <div
                    className="pe-1 mt-2 ps-2 mb-0"
                    style={{ marginLeft: "25px" }}
                  >
                    <span className={"filteredBadge"}>
                      <span>Group Name</span>
                      <span
                        className="ms-2 cursor-pointer"
                        onClick={this.clearFilter}
                      >
                        <CommonIcon fileName={"CloseSmallwhite"} />
                      </span>
                    </span>
                  </div>
                  <p
                    className="mb-0 mt-2 countValue ps-2"
                    style={{ marginLeft: "25px" }}
                  >
                    Count: {this.state.normalData.length}
                  </p>
                </>
              )}
              <div className="row">
                <div
                  className="groupcardmobile"
                  style={{ paddingRight: "2rem" }}
                >
                  {this.state.normalData.length < 1 && !this.state.isloading ? (
                    <div className="card sharpcorner1  cursor-pointer px-2 my-2 mt-2 p-2">
                      <div className="card-body">
                        <div
                          style={{
                            position: "absolute",
                            left: "0",
                            top: "-0.1px",
                            bottom: "-0.2px",
                            width: "4px",
                            backgroundColor: " rgb(33, 150, 243)",
                          }}
                        ></div>
                        <div className="row">
                          <div className="col-12  d-flex align-items-center">
                            <div className="row text-center w-100">
                              <div className="col-12">
                                <span
                                  className="nofound "
                                  style={{ fontWeight: "bold" }}
                                >
                                  No groups found
                                </span>
                              </div>
                              {/* <div className="col-12"><span className="reporttext12" style={{ fontWeight: "bold" }}>{}</span></div> */}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    this.state.normalData.map((element, inde) => {
                      return (
                        <div
                          className={`card sharpcorner1  cursor-pointer px-2 my-2  pt-1 pb-1 ${
                            inde == 0 ? "mt-3" : "mt-4"
                          }`}
                          style={{ minHeight: "162px" }}
                          onClick={() =>
                            this.handleEditId(
                              element.groupId,
                              element.groupName,
                              element.description,
                              element.totalMembers
                            )
                          }
                        >
                          <div className="card-body pt-0 pb-0">
                            <div
                              style={{
                                position: "absolute",
                                left: "0",
                                top: "-0.1px",
                                bottom: "-0.2px",
                                width: "4px",
                                backgroundColor: " rgb(33, 150, 243)",
                              }}
                            ></div>
                            <div className="row">
                              <div
                                className={`col-12 d-flex align-items-center mb-1 ${
                                  this.state.isMobile ? "pt-2" : ""
                                }`}
                              >
                                <div className="row">
                                  <div className="col-12">
                                    <span
                                      className="reporttext14mobile"
                                      style={{ fontWeight: "bold" }}
                                    >
                                      {element.groupName}
                                    </span>
                                  </div>
                                  {/* <div className="col-12"><span className="reporttext12" style={{ fontWeight: "bold" }}>{}</span></div> */}
                                </div>
                              </div>
                              <div className="col-6 d-flex align-items-start">
                                <div className="row ">
                                  <div className="col-12">
                                    <span className="reporttext14mobile">
                                      Total Members
                                    </span>
                                  </div>
                                  <div className="col-12">
                                    <span className="reporttext12">
                                      {element.totalMembers}
                                    </span>
                                  </div>
                                </div>
                              </div>
                              <div className="col-6 d-flex align-items-start">
                                <div className="row desc">
                                  <div className="col-12">
                                    <span className="reporttext14mobile">
                                      Description
                                    </span>
                                  </div>
                                  <div className="col-12">
                                    <span className="reporttext12desc">
                                      {" "}
                                      {element.description &&
                                      element.description.length > 70
                                        ? `${element.description.substring(
                                            0,
                                            70
                                          )}...`
                                        : element.description || "-"}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })
                  )}
                </div>
              </div>

              {/* EXIST GROUP FORM */}
              {/* <div
                                className="offcanvas offcanvas-end p-3 pt-0 ps-0 pb-0"
                                data-bs-scroll="false"
                                data-bs-backdrop
                                id="AddForm2"
                                aria-labelledby="offcanvasScrollingLabel"
                                style={{
                                    width: "calc(100%)",

                                    height: '100vh',

                                }}
                            >
                                <div className='d-flex align-items-start w-100'>
                                    <div className='d-flex align-items-start w-100'>
                                        <div className='leftsidepanelattrmobile'>
                                            <div className='d-flex justify-content-between ps-3 pb-1 wholeheader1mobile'>
                                                <h3 className='headername1'>{this.state.groupName}</h3>
                                                <button
                                                    data-bs-dismiss="offcanvas"
                                                    className="offcavasclose float-end mt--10"
                                                    onClick={() => this.closeForm()}
                                                >
                                                    <CommonIcon fileName={"Close"} />
                                                </button>
                                            </div>
                                            <div className='ps-4 mb-2 pathlabelgrp'>
                                                <label className='pathlabel'><span className='isblue'>Groups &gt;</span></label>
                                            </div>
                                            <div className='leftpanel1mobile pb-1'>
                                                <ul className='leftpanelulgroupmobile'>
                                                    <li className={`d-flex align-items-center ${this.state.showdetails ? "leftpanelli " : "leftpanelli1"}`} onClick={this.detailsmobile}><CommonIcon fileName={'idcardicon'} />&nbsp;&nbsp;Details</li>
                                                    <li className={`d-flex align-items-center ${this.state.showmember ? "leftpanelli" : "leftpanelli1"}`} onClick={this.membersmobile} ><CommonIcon fileName={'groupicon'} />&nbsp;&nbsp;Members</li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div> */}

              {/* ADD NEW GROUP */}
              <div
                className="offcanvas offcanvas-end w-100 ps-0 pe-0"
                tabIndex={-1}
                data-bs-scroll="false"
                data-bs-backdrop="true"
                id="AddGroup"
                aria-labelledby="offcanvasScrollingLabel"
                style={{
                  width: "calc(100%)",
                  height: "100vh",
                }}
              >
                <div className={`offcanvas-header px-4 pt-2 pb-3 mt-10`}>
                  <span className="headername1 px-2">Add Group</span>
                  <button
                    data-bs-dismiss="offcanvas"
                    className="offcavasclose"
                    onClick={() => this.closeGroupForm()}
                  >
                    <CommonIcon fileName={"Close"} />
                  </button>
                </div>

                <div
                  className="offcanvas-body px-4 pt-0"
                  style={{ overflow: "hidden" }}
                >
                  <div className="row ps-3" style={{ padding: "0rem 0rem" }}>
                    <div className="col-12  flex-1">
                      <FormLabel
                        className="formlabel-style w-100"
                        id="first-name-label"
                      >
                        Group Name<span className={`isrequired`}>*</span>
                      </FormLabel>

                      <TextField
                        error={this.state.newgroupnameerror}
                        id="email"
                        className={`filter_input br-4 }`}
                        // fullWidth label="First Name"
                        variant="filled"
                        value={this.state.newgroupname}
                        onChange={(e) => {
                          this.setState({ newgroupname: e.target.value });
                        }}
                        focused
                        style={{ width: "96%" }}
                      />

                      {this.state.newgroupnameerror && (
                        <div className="error-message" style={{ color: "red" }}>
                          {this.state.newgroupnameerror}
                        </div>
                      )}
                    </div>
                    <div className={`col-12 mt-3 flex-1`}>
                      <FormLabel
                        className="formlabel-style w-100"
                        id="first-name-label"
                      >
                        Description
                      </FormLabel>
                      <TextareaAutosize
                        // error={this.state.lastNameError}
                        id="description"
                        className={`filter_input br-4 }`}
                        // fullWidth label="First Name"
                        variant="filled"
                        value={this.state.description}
                        onChange={(e) =>
                          this.setState({ description: e.target.value })
                        }
                        focused
                        minRows={5}
                        style={{ width: "96%", paddingLeft: "13px" }}
                      />

                      {/* {this.state.lastNameError && (
                          <div className="error-message" style={{ color: 'red' }}>
                            {this.state.lastNameErrorMessage}
                          </div>
                        )} */}
                    </div>
                  </div>
                  <p class="ml-12" />
                  <div className="row mt-2">
                    <div className="col-12 pb-20 pr-28 ml-16">
                      {/* <button data-bs-dismiss="offcanvas" className={`btn-cancel btn-filter-action border-none ms-1`} variant="outlined" onClick={() => this.closeForm()}>Cancel</button> */}
                      <button
                        className={`btn-fun btn-action btn-filter-action`}
                        variant="primary"
                        onClick={() => this.addGroup()}
                      >
                        Add
                      </button>
                    </div>
                  </div>

                  <div>
                    <div className={`col-12 `}></div>
                  </div>
                </div>
              </div>

              {/* FILTER FOR FIRST PAGE */}
              <div
                className="offcanvas offcanvas-end"
                data-bs-scroll="false"
                data-bs-backdrop="false"
                id="FilterScreen1"
                aria-labelledby="offcanvasScrollingLabel"
              >
                <div className={`offcanvas-header px-4 pt-4 pb-3 mt-10`}>
                  <h6
                    id="offcanvasRightLabel"
                    className="modal-title head-span"
                    style={{ fontWeight: "600" }}
                  >
                    Filter
                  </h6>
                  <button
                    className="offcavasclose"
                    onClick={() => this.closeWebFilter1()}
                  >
                    <CommonIcon fileName={"Close"} />
                  </button>
                </div>

                <div className="offcanvas-body px-4 pt-0">
                  <div className="row">
                    <div
                      className="row"
                      style={{
                        padding: "1rem",
                        paddingTop: "0",
                        paddingRight: "0px",
                      }}
                    >
                      <div className={`col-12 mt-2 pe-2`}>
                        <TextField
                          id="jobOpTitle"
                          className="filter_input"
                          fullWidth
                          label="Group Name"
                          variant="filled"
                          value={this.state.choice.groupName}
                          onChange={(e) =>
                            this.lookupChange(e, "", "groupName")
                          }
                          focused
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row pe-4">
                  <div className="col-12 align_justify_end pb-20 ">
                    <Button
                      className="btn-clear mr-10 border-none"
                      variant="outlined"
                      onClick={() => this.clearFilter()}
                      sx={{
                        textTransform: "none",
                        borderRadius: 0, // Set borderRadius to 0 for sharp edges
                        "&:hover": {
                          borderRadius: 0, // Ensure sharp edges on hover as well
                        },
                      }}
                    >
                      Reset
                    </Button>
                    <button
                      className="btn-apply"
                      variant="primary"
                      onClick={() => this.applyFilter()}
                    >
                      Apply
                    </button>
                  </div>
                </div>
              </div>

              {/* DELETE POPUP MODAL */}
              <div
                className={`modal modal-style ${
                  this.state.openmemberdelete ? "show" : ""
                }`}
                id="deletemodal"
                tabindex="-1"
                aria-labelledby="exampleModalLabel"
                aria-hidden="true"
                style={{
                  display: this.state.openmemberdelete ? "block" : "none",
                  zIndex: "1070",
                }}
              >
                <div className="modal-dialog modal-dialog-centered">
                  <div className="modal-content shadow-lg bg-white rounded">
                    <div className="modal-body text-center">
                      <CommonIcon fileName={"deletemember"} />
                      <br />
                      <span>
                        Are you sure, you want to delete this member from group?
                      </span>
                    </div>
                    <div className="modal-footer justify-content-center">
                      <Button
                        className="btn-no px-4"
                        variant="primary"
                        onClick={() => this.noActions()}
                      >
                        No
                      </Button>{" "}
                      <Button
                        className="btn-action px-4"
                        variant="primary"
                        onClick={() => this.yesActions()}
                      >
                        Yes
                      </Button>{" "}
                    </div>
                  </div>
                </div>
              </div>

              {/* DELETE GROUP POPUP MODAL */}
              <div
                className={`modal modal-style ${
                  this.state.opendialogun ? "show" : ""
                }`}
                id="deletemodal"
                tabindex="-1"
                aria-labelledby="exampleModalLabel"
                aria-hidden="true"
                style={{
                  display: this.state.opendialogun ? "block" : "none",
                  zIndex: "1070",
                }}
              >
                <div className="modal-dialog modal-dialog-centered">
                  <div className="modal-content shadow-lg bg-white rounded">
                    <div className="modal-body text-center">
                      <CommonIcon fileName={"deletegroup"} />
                      <br />
                      <span>Are you sure, you want to delete this group?</span>
                    </div>
                    <div className="modal-footer justify-content-center">
                      <Button
                        className="btn-no px-4"
                        variant="primary"
                        onClick={() => this.noAction()}
                      >
                        No
                      </Button>{" "}
                      <Button
                        className="btn-action px-4"
                        variant="primary"
                        onClick={() => this.yesAction()}
                      >
                        Yes
                      </Button>{" "}
                    </div>
                  </div>
                </div>
              </div>

              {/* FILTER SCREEN FOR USER MEMBER */}
              <div
                className="offcanvas offcanvas-end ps-0 pe-0"
                data-bs-scroll="false"
                data-bs-backdrop="false"
                id="FilterScreenroles"
                aria-labelledby="offcanvasScrollingLabel"
              >
                <div className={`offcanvas-header px-4 pt-4 pb-3 mt-10`}>
                  <h6
                    id="offcanvasRightLabel"
                    className="modal-title head-span"
                    style={{ fontWeight: "600" }}
                  >
                    Filters
                  </h6>
                  <button
                    className="offcavasclose"
                    onClick={() => this.closeWebFilterMember()}
                  >
                    <CommonIcon fileName={"Close"} />
                  </button>
                </div>

                <div className="offcanvas-body px-4 pt-0">
                  <div className="row">
                    <div
                      className="row"
                      style={{
                        padding: "1rem",
                        paddingTop: "0",
                        paddingRight: "0px",
                      }}
                    >
                      <div className={`col-12 mt-2 pe-2`}>
                        <TextField
                          id="jobOpTitle"
                          className="filter_input"
                          fullWidth
                          label="Name"
                          variant="filled"
                          value={this.state.choice.name}
                          onChange={(e) => this.lookupChange(e, "", "name")}
                          focused
                        />
                      </div>
                      <div className={`col-12 mt-2 pe-2`}>
                        <TextField
                          id="jobOpTitle"
                          className="filter_input"
                          fullWidth
                          label="Email"
                          variant="filled"
                          value={this.state.choice.email}
                          onChange={(e) => this.lookupChange(e, "", "email")}
                          focused
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row pe-4">
                  <div className="col-12 align_justify_end pb-20">
                    <Button
                      className="btn-clear mr-10 border-none"
                      variant="outlined"
                      onClick={() => this.clearRoleFilter()}
                      sx={{
                        borderRadius: 0,
                        textTransform: "none", // This will prevent the text from being transformed to uppercase
                        "&:hover": {
                          borderRadius: 0,
                        },
                      }}
                    >
                      Reset
                    </Button>
                    <button
                      className="btn-apply"
                      variant="primary"
                      onClick={() => this.applyRoleFilter()}
                    >
                      Apply
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        <div
          className="offcanvas offcanvas-end p-3 pt-0 ps-0 pb-0"
          data-bs-scroll="false"
          data-bs-backdrop
          id="AddForm2"
          aria-labelledby="offcanvasScrollingLabel"
          style={{
            width: "calc(100%)",

            height: "100vh",
          }}
        >
          {!isWebMobile && !isMobile ? (
            <div className="d-flex align-items-start w-100">
              <div className="leftgrouppanel">
                <div className="leftsidepanel w-100">
                  <div className="d-flex justify-content-between ps-3  pb-1 wholeheader1">
                    <h3 className="headername1">Groups</h3>
                  </div>
                  <div className="leftpanel1 pb-1">
                    <ul className="leftpanelulgroup">
                      {this.state.normalData.map((e) => {
                        return (
                          <li
                            className={`${
                              this.state.groupName === e.groupName
                                ? "leftpanelli"
                                : "leftpanelli1"
                            }`}
                            onClick={() => this.handlegroupchnage(e)}
                          >
                            {e.groupName}
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                </div>
                <ul></ul>
              </div>

              <div className="d-flex align-items-start w-100">
                <div className="leftsidepanelattr">
                  <div className="d-flex justify-content-between ps-3 pb-1 wholeheader1">
                    <h3
                      className={`${
                        this.state.groupName.length < 20
                          ? "headername1"
                          : "lowerheadername"
                      }`}
                      style={{
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        width: "200px",
                      }}
                    >
                      <Tooltip title={this.state.groupName}>
                        <span>{this.state.groupName}</span>
                      </Tooltip>
                    </h3>
                  </div>
                  <div className="leftpanel1 pb-1">
                    <ul className="leftpanelulgroup">
                      <li
                        className={`d-flex align-items-center ${
                          this.state.showdetails
                            ? "leftpanelli "
                            : "leftpanelli1"
                        }`}
                        onClick={this.details}
                      >
                        <CommonIcon fileName={"idcardicon"} />
                        &nbsp;&nbsp;Details
                      </li>
                      <li
                        className={`d-flex align-items-center ${
                          this.state.showmember ? "leftpanelli" : "leftpanelli1"
                        }`}
                        onClick={this.members}
                      >
                        <CommonIcon fileName={"groupicon"} />
                        &nbsp;&nbsp;Members
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="w-100">
                  {this.state.showmember && (
                    <div className="w-100 p-3 pt-1 height100">
                      <div className="d-flex justify-content-between ps-1 pt-1  pb-1">
                        <h3 className="headername1 pt-1">Members</h3>
                        <div className="d-flex justify-content-end pb-2 pe-1 pt-2">
                          <button
                            className="btn-fun btn-new fs-7 me-2"
                            onClick={this.newUserGroupFormShow}
                          >
                            <CommonIcon fileName={"AddPlus"} />
                            Add
                          </button>
                          <button
                            data-bs-dismiss="offcanvas"
                            className="offcavasclose float-end mt--10 pe-0"
                            onClick={() => this.closeForm()}
                          >
                            <CommonIcon fileName={"Close"} />
                          </button>
                        </div>
                      </div>

                      <div className="ps-2 mt-2" style={{ width: "100%" }}>
                        <CustomListView
                          listData={this.state.assignedGroupMembers ?? []}
                          columns={this.state.columns}
                          handleDataFetch={this.handleDataFetch}
                          totalCount={this.state.totalCount}
                          isLoading={this.state.tableLoader}
                        />
                      </div>
                    </div>
                  )}
                  {this.state.showdetails && (
                    <div className="">
                      <div className="d-flex justify-content-between ps-3 pb-1 pt-2">
                        <h3 className="headername1">Details</h3>
                        <button
                          data-bs-dismiss="offcanvas"
                          className="offcavasclose float-end "
                          onClick={() => this.closeForm()}
                        >
                          <CommonIcon fileName={"Close"} />
                        </button>
                      </div>

                      <div className=" p-4 pe-0 pt-1 w-100">
                        <div className="row p-4 ps-2 pt-2 pe-1 ">
                          <div className="col-3 ps-1">
                            <h3 className="licenseheader">Group details</h3>
                          </div>
                          <div
                            className={`col-9 ${
                              this.state.editGroup ? "" : "pe-0"
                            }`}
                          >
                            <div
                              className={`row d-flex pe-0 ${
                                !this.state.editGroup ? "w-100" : ""
                              }`}
                            >
                              <div
                                className={
                                  !this.state.editGroup ? "col-10" : "col-12"
                                }
                              >
                                <div className="d-flex">
                                  <FormLabel className="formlabel-style1">
                                    Group Name{" "}
                                  </FormLabel>{" "}
                                  {!this.state.editGroup ? (
                                    <>
                                      {" "}
                                      <span className="px-3">-</span>
                                      <span className={`formlabel-input`}>
                                        {this.state.groupName}
                                      </span>
                                    </>
                                  ) : (
                                    ""
                                  )}
                                </div>
                                {this.state.editGroup ? (
                                  <>
                                    {" "}
                                    <TextField
                                      error={this.state.newgroupnameerror}
                                      id="email"
                                      fullWidth
                                      className={`filter_input br-4 }`}
                                      variant="filled"
                                      value={this.state.newgroupname}
                                      onChange={(e) => {
                                        this.setState({
                                          newgroupname: e.target.value,
                                        });
                                      }}
                                      focused
                                    />
                                    {this.state.newgroupnameerror && (
                                      <div
                                        className="error-message"
                                        style={{ color: "red" }}
                                      >
                                        {this.state.newgroupnameerror}
                                      </div>
                                    )}
                                  </>
                                ) : (
                                  ""
                                )}
                              </div>
                              {/* {!this.state.editGroup && (
                                <div className="col-2 pe-0">
                                  {!this.state.editGroup ? (
                                    <span
                                      className="isedit cursor-pointer float-end "
                                      onClick={this.editGroup}
                                    >
                                      <CommonIcon fileName={"editicon"} />
                                    </span>
                                  ) : (
                                    ""
                                  )}
                                </div>
                              )} */}
                            </div>
                            <div className="col-12 mt-3">
                              <div className="d-flex">
                                <FormLabel className="formlabel-style1">
                                  Total members{" "}
                                </FormLabel>
                                <span className={`formlabel-input `}>
                                  <span className="px-3">-</span>
                                  {this.state.totalMembers}
                                </span>
                              </div>
                            </div>
                            <div className="col-12 mt-3">
                              {" "}
                              <div className="d-flex align-items-start">
                                <FormLabel className="formlabel-style1">
                                  Description{" "}
                                </FormLabel>
                              </div>
                              {!this.state.editGroup ? (
                                <>
                                  <div className="text-justify  pe-2">
                                    {" "}
                                    <span
                                      className={`formlabel-input text-justify `}
                                    >
                                      {this.state.description}
                                    </span>
                                  </div>{" "}
                                </>
                              ) : (
                                ""
                              )}
                              {this.state.editGroup ? (
                                <TextareaAutosize
                                  id="description"
                                  className={`filter_input br-4 }`}
                                  variant="filled"
                                  value={this.state.description}
                                  onChange={(e) =>
                                    this.setState({
                                      description: e.target.value,
                                    })
                                  }
                                  focused
                                  minRows={5}
                                  style={{ width: "100%", paddingLeft: "13px" }}
                                />
                              ) : (
                                ""
                              )}
                            </div>

                            {!this.state.editGroup ? (
                              <div className="col-4 mb-3 mt-3">
                                {/* <button
                                  className={`btn-fun btn-action btn-filter-action`}
                                  variant="primary"
                                  onClick={this.editGroup}
                                >
                                  Edit
                                </button> */}
                                <span
                                  className="editButton cursor-pointer ps-3 pe-3 me-2"
                                  onClick={this.editGroup}
                                >
                                  Edit
                                </span>
                                <span
                                  className="unsubscribe cursor-pointer ps-3 pe-3"
                                  onClick={this.deleteGroup}
                                >
                                  Delete
                                </span>
                              </div>
                            ) : (
                              ""
                            )}
                            {this.state.editGroup ? (
                              <div className="col-12 pb-20 pr-28 mt-2">
                                <button
                                  className={`btn-fun btn-action btn-filter-action`}
                                  variant="primary"
                                  onClick={this.updateGroup}
                                >
                                  Save
                                </button>
                                <button
                                  className={`btn-cancel btn-filter-action border-none`}
                                  variant="outlined"
                                  onClick={this.cancelGroup}
                                >
                                  Cancel
                                </button>
                              </div>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  {this.state.showsroles && (
                    <div>
                      <h3>ROLES ASSIGN</h3>
                    </div>
                  )}
                </div>
              </div>
            </div>
          ) : (
            <div className="d-flex align-items-start w-100">
              <div className="d-flex align-items-start w-100">
                <div className="leftsidepanelattrmobile">
                  <div className="d-flex justify-content-between ps-3 pb-1 wholeheader1mobile">
                    <h3 className="headername1">{this.state.groupName}</h3>
                    <button
                      data-bs-dismiss="offcanvas"
                      className="offcavasclose float-end mt--10"
                      onClick={() => this.closeForm()}
                    >
                      <CommonIcon fileName={"Close"} />
                    </button>
                  </div>
                  <div className="ps-4 mb-2 pathlabelgrp">
                    <label className="pathlabel">
                      <span className="isblue">Groups &gt;</span>
                    </label>
                  </div>
                  <div className="leftpanel1mobile pb-1">
                    <ul className="leftpanelulgroupmobile">
                      <li
                        className={`d-flex align-items-center ${
                          this.state.showdetails
                            ? "leftpanelli "
                            : "leftpanelli1"
                        }`}
                        onClick={this.detailsmobile}
                      >
                        <CommonIcon fileName={"idcardicon"} />
                        &nbsp;&nbsp;Details
                      </li>
                      <li
                        className={`d-flex align-items-center ${
                          this.state.showmember ? "leftpanelli" : "leftpanelli1"
                        }`}
                        onClick={this.membersmobile}
                      >
                        <CommonIcon fileName={"groupicon"} />
                        &nbsp;&nbsp;Members
                      </li>
                      {/* <li className={`${this.state.showsroles ? "leftpanelli" : "leftpanelli1"}`} onClick={this.roles}><CommonIcon fileName={'settingicon'} />&nbsp;&nbsp;Assignments</li> */}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
        {/* DETAILS PAGE */}
        <div
          className="offcanvas offcanvas-end"
          data-bs-scroll="false"
          data-bs-backdrop="false"
          id="groupdetails"
          aria-labelledby="offcanvasScrollingLabel"
        >
          <div className="row p-4 ps-2 pt-3 pe-0 pb-0">
            <div className="col-12 d-flex justify-content-between">
              <h3 className="groupdetailsheader">Group details</h3>
              <button
                className="offcavasclose"
                onClick={() => this.closegroupdetails()}
              >
                <CommonIcon fileName={"Close"} />
              </button>
            </div>
          </div>
          <div className="ps-2 mt-2">
            <label className="pathlabel">
              Groups &gt;<span className="isblue">Details</span>
            </label>
          </div>
          <div className="row ps-2 mt-2">
            <div className="col-12 editgroupwrap">
              <div className="col-12 d-flex me-1">
                <div className="col-10 ">
                  <FormLabel className="formlabel-style1 w-100">
                    Group Name
                    <span
                      className={`${
                        this.state.editGroup ? "isrequired" : "d-none"
                      }`}
                    >
                      *
                    </span>
                  </FormLabel>
                  {/* <div className='d-flex'><FormLabel className="formlabel-style1">Group Name &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;- &nbsp;&nbsp;&nbsp;</FormLabel> {!this.state.editGroup ? <span className={`formlabel-input`}>{this.state.groupName}</span> : ""}</div> */}
                  {!this.state.editGroup ? (
                    <FormLabel className={`formlabel-input w-100 `}>
                      {this.state.groupName}
                    </FormLabel>
                  ) : (
                    ""
                  )}
                  {this.state.editGroup ? (
                    <>
                      {" "}
                      <TextField
                        error={this.state.newgroupnameerror}
                        id="email"
                        className={`filter_input br-4 }`}
                        // fullWidth label="First Name"
                        variant="filled"
                        value={this.state.newgroupname}
                        onChange={(e) => {
                          this.setState({ newgroupname: e.target.value });
                        }}
                        focused
                        style={{ width: "90%" }}
                      />
                      {this.state.newgroupnameerror && (
                        <div className="error-message" style={{ color: "red" }}>
                          {this.state.newgroupnameerror}
                        </div>
                      )}
                    </>
                  ) : (
                    ""
                  )}
                </div>
                {/* <div className="col-2 ">
                  {!this.state.editGroup ? (
                    <span
                      className="isedit cursor-pointer float-end mt--2"
                      onClick={this.editGroup}
                    >
                      <CommonIcon fileName={"editicon"} />
                    </span>
                  ) : (
                    ""
                  )}
                </div> */}
              </div>
              <div className="col-12 mt-3">
                <FormLabel className="formlabel-style1">
                  Total members
                </FormLabel>
                <br />
                <FormLabel className={`formlabel-input `}>
                  {this.state.totalMembers}
                </FormLabel>
              </div>
              <div className="col-12 mt-3">
                {/* <div className='d-flex align-items-start'><FormLabel className="formlabel-style1">Description&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;    </FormLabel>- &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{!this.state.editGroup ? <span className={`formlabel-input `}>{this.state.description}</span> : ""}</div> */}
                <FormLabel className="formlabel-style1 w-100">
                  Description
                </FormLabel>
                {!this.state.editGroup ? (
                  <FormLabel className="formlabel-input w-100">
                    {this.state.description}
                  </FormLabel>
                ) : (
                  ""
                )}
                {this.state.editGroup ? (
                  <TextareaAutosize
                    // error={this.state.lastNameError}
                    id="description"
                    className={`filter_input br-4 }`}
                    variant="filled"
                    value={this.state.description}
                    onChange={(e) =>
                      this.setState({ description: e.target.value })
                    }
                    focused
                    minRows={5}
                    style={{ width: "100%", paddingLeft: "13px" }}
                  />
                ) : (
                  ""
                )}
              </div>

              {!this.state.editGroup ? (
                <div className="col-4 mb-3 mt-3">
                  <span
                    className="editButton cursor-pointer ps-3 pe-3 me-2"
                    onClick={this.editGroup}
                  >
                    Edit
                  </span>
                  <span
                    className="unsubscribe cursor-pointer  ps-3 pe-3"
                    onClick={this.deleteGroup}
                  >
                    Delete
                  </span>
                </div>
              ) : (
                ""
              )}
              {this.state.editGroup ? (
                <div className="col-12 pb-20 pr-28 mt-2">
                  <button
                    className={`btn-fun btn-action btn-filter-action`}
                    variant="primary"
                    onClick={this.updateGroup}
                  >
                    Save
                  </button>
                  <button
                    className={`btn-cancel btn-filter-action border-none`}
                    variant="outlined"
                    onClick={this.cancelGroup}
                  >
                    Cancel
                  </button>
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
        </div>

        {/* MEMEBERS PAGE */}
        <div
          className="offcanvas offcanvas-end"
          data-bs-scroll="false"
          data-bs-backdrop="false"
          id="groupmembers"
          aria-labelledby="offcanvasScrollingLabel"
        >
          <div className="row p-4 ps-2 pt-3 pe-0 pb-0">
            <div className="col-12 d-flex justify-content-between">
              <h3 className="groupdetailsheader">Members</h3>
              <button
                className="offcavasclose"
                onClick={() => this.closegroupmembers()}
              >
                <CommonIcon fileName={"Close"} />
              </button>
            </div>
          </div>
          <div className="ps-2 d-flex justify-content-between">
            <label className="pathlabel">
              Groups &gt;<span className="isblue">Members</span>
            </label>
            <div>
              <button
                className="btn-fun btn-new fs-7 me-2"
                onClick={this.newUserGroupFormShow}
              >
                <CommonIcon fileName={"AddPlus"} />
                Add
              </button>
              <button
                className="btn-fun fs-7 ps-3 pe-3 me-3"
                onClick={this.toggleWebFilterMember}
              >
                <CommonIcon
                  fileName={
                    this.state.isFilterAppliedRole ? "Filtered" : "Filter"
                  }
                />
              </button>
            </div>
          </div>
          {this.state.isFilterAppliedRole && (
            <>
              <div className="mt-3 mb-0" style={{ paddingRight: "2rem" }}>
                {this.state.filterOptions.name !== "" &&
                  this.state.filterOptions.name !== null &&
                  this.state.filterOptions.name !== undefined && (
                    <span className="filteredBadge">
                      <span>Name</span>
                      <span onClick={this.applyRoleFilterName} className="ms-2">
                        <CommonIcon fileName={"CloseSmallwhite"} />
                      </span>
                    </span>
                  )}
                {this.state.filterOptions.email !== "" &&
                  this.state.filterOptions.email !== null &&
                  this.state.filterOptions.email !== undefined && (
                    <span className="filteredBadge">
                      <span>Email</span>
                      <span
                        onClick={this.applyRoleFilterEmail}
                        className="ms-2"
                      >
                        <CommonIcon fileName={"CloseSmallwhite"} />
                      </span>
                    </span>
                  )}
              </div>
              <p className="mb-0 mt-2 countValue">
                Count: {this.state.assignedGroupMembers.length}
              </p>
            </>
          )}
          <div className="row ps-2 mt-2 overflowgroupmembers">
            {this.state.assignedGroupMembers.map((element) => {
              return (
                <div
                  className="card sharpcorner  cursor-pointer px-2 my-2 mt-2 "
                  style={{ width: "94%" }}
                >
                  <div className="card-body pt-0 pb-0">
                    <div
                      style={{
                        position: "absolute",
                        left: "0",
                        top: "-0.1px",
                        bottom: "-0.2px",
                        width: "4px",
                        backgroundColor: " rgb(33, 150, 243)",
                      }}
                    ></div>
                    <div className="row">
                      <div className="col-12 d-flex align-items-center mb-1">
                        <div className="row">
                          <div className="col-12">
                            <span
                              className="reporttext14"
                              style={{ fontWeight: "bold" }}
                            >
                              {element.name}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="col-6 d-flex align-items-center">
                        <div className="row ">
                          <div className="col-12">
                            <span className="reporttext14">Email</span>
                          </div>
                          <div className="col-12">
                            <span className="reporttext12">
                              {element.email}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="col-6 d-flex align-items-center justify-content-end ">
                        <span
                          className="float-end cursor-pointer"
                          onClick={() =>
                            this.handleDelete(element.userId, element.email)
                          }
                        >
                          <CommonIcon fileName={"DeleteIcon"} />
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
        <div
          className="offcanvas offcanvas-end"
          tabIndex={-1}
          data-bs-scroll="false"
          data-bs-backdrop="false"
          id="AddGroupmain"
          aria-labelledby="offcanvasScrollingLabel"
        >
          <div className={`offcanvas-header   pb-2`}>
            <span className="headername1 px-2 ">Add Members</span>
            <button
              data-bs-dismiss="offcanvas"
              className="offcavasclose "
              onClick={() => this.closeUserGroupForm()}
            >
              <CommonIcon fileName={"Close"} />
            </button>
          </div>

          <div className="offcanvas-body pt-3" style={{ overflow: "hidden" }}>
            <div className="row" style={{ padding: "0rem 1rem" }}>
              <div className="col-12  flex-1">
                <div className="d-flex align-items-center justify-content-start col-lg-12 col-md-12 col-sm-12 pt-0 p-1 ps-0">
                  <Autocomplete
                    className="col-12"
                    id="autocom"
                    multiple
                    error={this.state.memberError}
                    options={this.state.unAssignedUsers}
                    getOptionLabel={(option) => `${option.email}`}
                    renderOption={(props, option) => (
                      <li
                        {...props}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          fontSize: "12px",
                        }}
                      >
                        <Avatar sx={{ width: 35, height: 35, marginRight: 2 }}>
                          {option.name.charAt(0)}
                        </Avatar>
                        <div>
                          <strong>{option.name}</strong>
                          <div>{option.email}</div>
                        </div>
                      </li>
                    )}
                    value={this.state.selecteduserssss} // Reflects the current selected users
                    onChange={this.handleUserChange}
                    renderInput={(params) => (
                      <div className="d-flex">
                        <TextField
                          className="addadmininput"
                          id="textin"
                          {...params}
                          variant="filled"
                          error={this.state.memberError}
                          helperText={
                            this.state.memberError
                              ? "Select a member to add"
                              : ""
                          }
                          InputProps={{
                            ...params.InputProps,
                            endAdornment: null, // Removes the dropdown arrow
                            sx: {
                              height: "max-content",
                              "& .MuiAutocomplete-popupIndicator": {
                                display: "none", // Ensure any popup indicator is hidden
                              },
                            },
                            inputProps: {
                              ...params.inputProps,
                              style: {
                                padding: 0,
                                height: "100%",
                                display: "flex",
                                paddingBottom: "20px",
                              },
                            },
                          }}
                        />
                      </div>
                    )}
                    sx={{ width: "100%", marginRight: 2 }}
                  />
                </div>
              </div>
            </div>
            <p class="ml-12" />
            <div className="row mt-2">
              <div className="col-12 pb-20 pr-28 ml-19 ps-2">
                <button
                  onClick={this.savetable}
                  className="btn-fun btn-new fs-7 ps-4 pe-4"
                >
                  Add
                </button>
                &nbsp;&nbsp;
              </div>
            </div>

            <div>
              <div className={`col-12 `}></div>
            </div>
          </div>
        </div>
        <Backdrop className="spinner-backdrop" open={this.props.isLoading1}>
          <CircularProgress color="primary" />
        </Backdrop>
      </>
    );
  }
}
const mapDispatchToProps = (dispatch) => {
  return {
    toggleMenu: () => dispatch(toggleMenu()) || false,
    // sideMenu: () => dispatch(sideMenu()) || false,
    dispatch,
  };
};

function mapStateToProps(state) {
  return {
    getapplication: state.applicationReducer.getapplication,
    getApplicationLicenseStatus:
      state.applicationReducer.getApplicationLicenseStatus,
    getApplicationUsers: state.applicationReducer.getApplicationUsers,
    auditLog: state.applicationReducer.auditLog,
    userRoleAssign: state.applicationReducer.userRoleAssign,
    isLoading: state.commonReducer.isLoading,
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Groups));
